import React from 'react';
import Seo from '../../components/utils/Seo';
import BodyFaqPage from './body/BodyFaqPage'
import Footer from '../../components/marketing/footer/Footer';
import NavBar from '../../components/marketing/navbar/NavBar';
import HeaderFaq from '../../components/marketing/pageSections/faq/HeaderFaq';


function Faqs(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Réponses aux questions les plus posés"
                description="Rita la spécialiste en traduction des langues. rita vous propose plusieurs services pour traduire vos documents et sites web"
            />
            <NavBar />
            <HeaderFaq />
            <BodyFaqPage />
            <Footer />
        </div>
    );
}

export default Faqs;